export const defaultControllerAttributes = {
  visible: true,
  style: {
    x: 0,
    y: 0,
    dx: 0,
    dy: 0,
    size: 20
  },
  order: 0,
  space: 10
};

/**
 * 滑轨默认[长度,宽度]
 */
export const RailDefaultSize = [200, 10];
